import { Alert } from '@/components/ui/alert'
import { Checkbox } from '@/components/ui/checkbox'
import type { EventSummary } from '@/pages/DiscountCodesPage'

export function DiscountCodeEventRestrictions({
  eventIds,
  events,
  loading,
  failed,
  onChange,
}: {
  eventIds: number[]
  events: EventSummary[]
  loading: boolean
  failed: boolean
  onChange: (eventIds: number[]) => void
}) {
  return (
    <div>
      <p className="pb-2 text-caption font-medium text-foreground">Events</p>
      {loading ? (
        <p className="text-caption text-muted-foreground">Loading Events...</p>
      ) : failed ? (
        <Alert>Events unavailable</Alert>
      ) : (
        <div className="flex flex-wrap gap-x-4 gap-y-2">
          {events.map((event) => (
            <label key={event.id} className="flex items-center gap-2 text-body-sm text-foreground">
              <Checkbox
                aria-label={event.name}
                checked={eventIds.includes(event.id)}
                onCheckedChange={(checked) =>
                  onChange(
                    checked ? [...eventIds, event.id] : eventIds.filter((id) => id !== event.id),
                  )
                }
              />
              {event.name}
            </label>
          ))}
        </div>
      )}
    </div>
  )
}
